
<!--Delete Modal-->
<div class="modal fade" :id="elementId" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header modal-header-warning">
                <h5 class="modal-title" id="deleteModalLabel">{{titleForModal}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onNoClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                {{message}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal"
                        @click="onNoClick"
                        :disabled="loading">
                    No
                </button>
                <button type="button" class="btn btn-outline-primary waves-effect waves-light"
                        @click="onYesClick"
                        :disabled="loading">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="loading"></span>
                    Yes
                </button>
            </div>
        </div>
    </div>
</div>
